import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import TicketStatusForm from '@/modules/ticket_status/components/TicketStatusForm.vue';
import { TicketStatus, useTicketStatus } from '@/modules/ticket_status/TicketStatus';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketStatusEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const ticketStatus = ref<TicketStatus | null>(null);

const load = async () => {
	try {
		const response = await useTicketStatus().get(route.params.id as string);
		if (response) {
			ticketStatus.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'ticket_status.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	ticketStatus.value = u;
	Flash.success($gettext('Statusen har sparats.'));
};

const cancel = () => {
	router.push({ name: 'ticket_status.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TicketStatusForm, {
    "page-title": _unref($gettext)('Redigera status'),
    "ticket-status": ticketStatus.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "ticket-status"]))
}
}

})